import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { SupportMenuComponent } from '@bingads-webui-campaign-react/pmax-support-components';

export const SDKSupportMenu = () => {
  const { SupportOptions } = useContext(ServerContext);
  const i18n = useContext(I18nContext);
  const headerText = i18n.getString(_TL_('Microsoft Advertising'));
  return (
    <SupportMenuComponent
      supportOptions={{
        ...SupportOptions,
        headerText,
      }}
    />
  );
};
